<!-- Modal -->
<div class="modal fade" [id]="id" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" id="modalLabel">{{header}}</div>
        <button type="button" class="close" aria-label="Close" (click)="proceedCancel()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p><strong>Warning</strong></p>
        <p>An active record of a vehicle with registration number <strong>{{rego}}</strong> already exists in the system. 
         <br/><br/>Please contact support for assistance</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="proceedYes()">Close</button>
      </div>
    </div>
  </div>
</div>
